import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Logo } from "../../components/Logo";
import { PublicPageFrame } from "../../components/layout/PublicPageFrame";

const cardClass =
  "bg-white/[0.92] backdrop-blur-[8px] rounded-2xl shadow-2xl p-8 w-full border border-white/20 max-w-md text-center";

export function ContratarGraciasPage() {
  const [searchParams] = useSearchParams();
  const seguroId = searchParams.get("seguro");
  const email = sessionStorage.getItem("contratar_gracias_email")?.trim() ?? "";

  return (
    <PublicPageFrame>
      <div className={cardClass}>
        <Logo className="mx-auto mb-6 h-10 scale-[2] object-contain" />
        <CheckCircle2 className="mx-auto mb-4 h-16 w-16 text-green-600" aria-hidden />
        <h1 className="text-xl font-semibold text-[#2C2C2C]">¡Seguro contratado correctamente!</h1>
        <p className="mt-4 text-sm text-gray-700">
          {email ? (
            <span>
              Recibirás tu certificado en <strong>{email}</strong> en breve.
            </span>
          ) : (
            "Recibirás tu certificado por email en breve."
          )}
        </p>
        {seguroId ? (
          <p className="mt-3 text-xs text-gray-500">
            Referencia de pago: seguro n.º {seguroId}
          </p>
        ) : null}
      </div>
    </PublicPageFrame>
  );
}
